import { createSlice } from "@reduxjs/toolkit";
import { appRestart } from "src/duck/actions";
import { closeWizard } from "src/modules/pairing/duck/actions";

const initialState = {
  isResponding: false,
  request: null,
  error: false
};

const pairingResponderSlide = createSlice({
  name: "pairingResponder",
  initialState,
  reducers: {
    receivedRequest(state, { payload }) {
      state.isResponding = true;
      state.request = payload;
    },
    pairingFailed(state) {
      state.error = true;
    },
    resetState() {
      return initialState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(appRestart, () => {
        return initialState;
      })
      .addCase(closeWizard, () => {
        return initialState;
      });
  }
});

export { pairingResponderSlide };
export default pairingResponderSlide.reducer;
